import React, { useEffect, useMemo, useState } from "react";
import "./QuestionnairePickerModal.css";

const QuestionnairePickerModal = ({
  questionnaires,
  onSelect,
  onClose,
  loading,
}) => {

  const [search, setSearch] = useState("");

  const filteredQuestionnaires = useMemo(() => {
    return [...questionnaires]
      .sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", undefined, {
          sensitivity: "base",
        })
      )
      .filter(q =>
        q.name?.toLowerCase().includes(search.toLowerCase())
      );
  }, [questionnaires, search]);

  return (
    <div className="questionnaire-modal-backdrop" onClick={onClose}>
      <div
        className="questionnaire-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="questionnaire-modal__header">
          Select Questionnaire
        </div>

        <div className="questionnaire-modal__search">
          <input
            type="text"
            placeholder="Search questionnaire…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="questionnaire-modal__list">
          {loading && <div className="questionnaire-modal__empty">Loading…</div>}

          {!loading && questionnaires.length === 0 && (
            <div className="questionnaire-modal__empty">
              No questionnaires available
            </div>
          )}

          {!loading && filteredQuestionnaires.length === 0 && (
            <div className="questionnaire-modal__empty">
              No matching questionnaires
            </div>
          )}

          {filteredQuestionnaires.map((q) => (
            <div
              key={q.id}
              className="questionnaire-modal__item"
              onClick={() => onSelect(q)}
            >
              <div className="questionnaire-modal__item-title">
                {q.name}
              </div>
              {q.description && (
                <div className="questionnaire-modal__item-subtitle">
                  {q.description}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="questionnaire-modal__footer">
          <button
            className="questionnaire-modal__cancel"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};


export default QuestionnairePickerModal;
